import { Component, Input } from '@angular/core';

export interface TechnicalDetail {
  key: string,
  value: string
}

@Component({
  selector: 'kion-technical-data',
  templateUrl: './technical-data.component.html',
  styleUrls: ['./technical-data.component.scss']
})
export class TechnicalDataComponent {

  @Input() technicalDetails: TechnicalDetail[];

  showCompleteList: boolean;

  get list(): TechnicalDetail[] {
    if (this.showCompleteList) {
      return this.technicalDetails;
    }
    return this.technicalDetails.slice(0, 8);
  }

  showAll() {
    this.showCompleteList = true;
  }
}
